// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"237e7067","451":"ce86f3fc","482":"2c8656db","710":"b84b2bb1"}[chunkId] + ".chunk.js";
};